<template>
  <div v-if="masterCampaign">
    <vx-card>
      <vs-row vs-justify="space-between">
        <vs-col vs-w="6">
          <h3 class="mr-4">Generated venue campaigns</h3>
          <p class="mt-5">
            The campaign has been assigned to the following venues. <br />
            Here you can review them and decide to approve or reject.
          </p>
        </vs-col>
      </vs-row>

      <vs-row class="mt-2">
        <vs-button @click="onRefresh">Refresh list</vs-button>
      </vs-row>

      <!-- table -->
      <div class="data-list-container data-list-list-view">
        <!-- <h3>{{ activeVenue.name }}</h3> -->
        <vs-table
          ref="table"
          class="mt-8"
          v-model="selected"
          pagination
          search
          :data="venueCampaigns"
          @selected="onClicked(selected.id)"
        >
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <div class="flex flex-wrap-reverse items-center data-list-btn-container">
              <!-- ADD NEW -->
            </div>

            <!-- ITEMS PER PAGE -->
          </div>
          <template slot="thead">
            <vs-th>Venue name</vs-th>
            <!-- <vs-th>Category</vs-th> -->
            <vs-th>Status</vs-th>
            <vs-th>VM fill out by</vs-th>
            <vs-th>Send by</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
                <vs-td>
                  <p class="product-name font-medium truncate">
                    {{ tr.venueName }}
                  </p>
                </vs-td>
                <vs-td>
                  <vs-chip :color="statusObject(tr.status).color" class="product-order-status">
                    {{ statusObject(tr.status).text }}
                  </vs-chip>
                </vs-td>
                <vs-td>
                  <p class="product-category">
                    {{ moment(tr.approvedByDate).format("DD-MM-yyyy") }}
                  </p>
                </vs-td>
                <vs-td>
                  <p class="product-category">
                    {{ moment(tr.sendByDate).format("DD-MM-yyyy") }}
                  </p>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vx-card>

    <preview-popup ref="previewPopup" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import campaignMixin from "@/views/mixins/campaignMixin";
import PreviewPopup from "./PreviewCampaignPopup.vue";

export default {
  components: { PreviewPopup },
  mixins: [campaignMixin],
  props: ["masterCampaign"],
  data() {
    return {
      moment,
      selected: [],
    };
  },
  methods: {
    async onClicked(id) {
      await this.$store.dispatch("venueCampaigns/get", id);
      this.$refs.previewPopup.show(this.venueCampaign, this.masterCampaign);
    },
    async onRefresh() {
      await this.$store.dispatch("venueCampaigns/getForMasterCampaign", this.masterCampaign.id);
    },
  },
  computed: {
    ...mapGetters({
      venueCampaigns: "venueCampaigns/masterVenueCampaigns",
      venueCampaign: "venueCampaigns/venueCampaign",
    }),
  },

  async created() {
    console.log("Getting for id", this.masterCampaign.id);
    await this.$store.dispatch("venueCampaigns/getForMasterCampaign", this.masterCampaign.id);
  },
};
</script>

<style lang="scss">
</style>
